// extracted by mini-css-extract-plugin
module.exports = {"load-more":"topic-content_load-more__PWAxf"};